module.exports = __webpack_public_path__ + "static/media/book.87c73515.svg";